import { Component, AfterContentInit, ElementRef, ViewChild, Input, Output, EventEmitter, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ToolService } from 'src/app/services/tool-service';
import { MapComponent } from '../map/map.component';
import { BufferSrc, BufferUnits } from 'src/app/model/buffersrc';

@Component({
  selector: 'app-buffer-form',
  templateUrl: './buffer-form.component.html',
  styleUrls: ['./buffer-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BufferFormComponent implements AfterContentInit {

  @ViewChild('formElement', { static: true }) formElement: ElementRef;
  @ViewChild('unitOptions', { static: true }) unitOptions: ElementRef;
  @ViewChild('toggleButton', { static: true }) toggleButton: ElementRef;
  @ViewChild('unitInput', { static: true }) unitInput: ElementRef;
  @Input() units: BufferUnits = 'ft';
  @Output() unitsChange = new EventEmitter<BufferUnits>();
  @Input() value = 0;
  @Output() valueChange = new EventEmitter<number>();
  @Input() direction = 'down';
  @Input() local: boolean = false;
  public unitsShowing = false;
  private map: MapComponent;
  public hideOptions = true;
  public unitLabel = '';

  constructor(private domNode: ElementRef, private toolService: ToolService, private cdr: ChangeDetectorRef) { }

  ngAfterContentInit() {
    this.domNode.nativeElement.addEventListener('click', (event) => {
      if (event.currentTarget !== this.formElement.nativeElement) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    })

    $(this.unitInput.nativeElement).on('keyup', (event) => {
      this.UpdateBuffer();
    });

    $(this.formElement.nativeElement).on('submit', (event) => {
      if (event.preventDefault) {
        event.preventDefault();
      }
      this.UpdateBuffer();
      // this.ToggleClass('hidden', true);
      return false;
    });

    $('button', $(this.unitOptions.nativeElement)).on('click', (event) => {
      this.SetValue((event.currentTarget as HTMLButtonElement).value);
      event.stopImmediatePropagation();
    });

    this.SetValue(this.units);
  }
  SetBufferValue(value, units) {
    this.SetValue(units);
    this.unitInput.nativeElement.value = value;
    this.UpdateBuffer();
  }
  UpdateBuffer() {
    const bufferVal = Number(this.unitInput.nativeElement.value);
    const bufferSrc: BufferSrc = new BufferSrc(bufferVal, this.units);

    if (!!this.map) {
      if (!this.local) {
        this.toolService.DoAction('info/set-buffer', this.map, { bufferSrc: (bufferSrc) });
        if (['', null, 0].indexOf(bufferVal) === -1) {
          $('body').toggleClass('global-buffer-set', true);
        } else {
          $('body').toggleClass('global-buffer-set', false);
        }
      }
    }
    this.valueChange.emit(bufferSrc.value);
    this.cdr.detectChanges();
  }
  GetBufferSrc(): BufferSrc {
    const bufferVal = Number(this.unitInput.nativeElement.value);
    const bufferSrc: BufferSrc = new BufferSrc(bufferVal, this.units);
    return bufferSrc;
  }
  SetMap(map) {
    this.map = map;
  }
  SetValue(value) {
    this.units = value;
    this.unitsChange.emit(value);
    this.unitLabel = value + ' ';
    //(this.toggleButton.nativeElement as HTMLButtonElement).innerHTML = value + ' ';
    $(this.unitOptions.nativeElement).toggleClass('hidden', true);
    this.UpdateBuffer();
    this.cdr.detectChanges();
    this.unitInput.nativeElement.focus();
  }
  Show() {
    this.unitInput.nativeElement.focus();
    const uoStyle = this.unitOptions.nativeElement.style;

    if (this.direction === 'down') {
      /*uoStyle.position = 'absolute';
      uoStyle.left = 'Calc( ' + $(this.domNode.nativeElement).width() + 'px - ' +
        $(this.unitOptions.nativeElement).width() + 'px )';
      uoStyle.top = $('.input-group', this.domNode.nativeElement).height() + 'px';
      */
    }
  }
  HandleUpdated(isVis: boolean) {
    if (isVis === true) {
      window.requestAnimationFrame(() => {
        this.unitInput.nativeElement.focus();
      })
    }
  }
  ToggleClass(className, onOff: boolean = null) {
    return;
    if (onOff !== null) {
      $(this.domNode.nativeElement).toggleClass(className, !onOff);

    } else {
      $(this.domNode.nativeElement).toggleClass(className);
    }
  }
  UnitOptionsClicked(event: Event) {
    this.unitsShowing = !this.unitsShowing;
    this.cdr.detectChanges();
  }
  HandleUnit(unit: string) {
    this.unitLabel = unit;
    this.cdr.detectChanges;
    this.unitsShowing = false;
  }
  PreventEvent(event: Event) {
    event.preventDefault();
    if (event.cancelable) {
      event.cancelBubble = true;
    }
  }
  Focus() {
    this.unitInput.nativeElement.focus();
  }
}
